import { useRefinementList } from 'react-instantsearch'
import { attributesForFaceting } from './AlgoliaFilters'

/**
 * Hidden component that mounts all refinement widgets to ensure
 * useCurrentRefinements can detect refinements from URL parameters.
 * This is necessary when facet panels are not rendered (e.g., mobile view
 * or category-based filtering) but we still need refinements to work.
 */
export const HiddenRefinementWidgets = () => {
  // Mount all refinement widgets invisibly so useCurrentRefinements works
  attributesForFaceting.forEach(({ attribute }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useRefinementList({ attribute })
  })

  // This component renders nothing but ensures widgets are mounted
  return null
}
